import { create } from "zustand"
import { SidebarState } from "./types"

const useSidebarStore = create<SidebarState>((set: any, get: any) => ({
    open: true,
    mobileOpen: false,
    setOpen: (value: boolean) => set({ open: value }),
    toggle: () => set({ open: !get().open }),
    setMobileOpen: (value: boolean) => set({ mobileOpen: value }),
}))

export { useSidebarStore }
